import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const LoyaltyPointsInfos = ({ dataId, id, values }) => (
  <span data-id={dataId}>
    <> + </>
    <FormattedMessage id={id} values={{ points: values }} />
  </span>
);

LoyaltyPointsInfos.propTypes = {
  dataId: PropTypes.string,
  id: PropTypes.string,
  values: PropTypes.number
};
